<template>
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <table class="table">
        <tbody>
          <tr class="shadow-sm" v-for="(info, index) in rows" :key="index">
            <td-info-tag
              v-if="showInfoTag(info)"
              :data="info.value"
              :tdLabel="`${info.label}: `"
              :fieldTag="info.fieldTag"
              effect="dark"
            />
            <td
              :style="{
                wordBreak: 'auto-phrase',
                textAlign: 'justify',
              }"
              v-else-if="
                typeof info.visibility === 'undefined' ||
                Boolean(info.visibility)
              "
            >
              <h6 class="mb-1">
                <strong>{{ info.label }}:</strong>
              </h6>
              <span v-if="validateIsset(info.value)" class="mt-2">
                {{ info.value }}
              </span>
              <el-tag v-else type="warning" effect="dark" class="mt-2">{{
                $t('common_words.no_assignment')
              }}</el-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import i18n from 'src/i18n';
import TdInfoTag from 'src/components/Tables/TdInfoTag.vue';

export default {
  name: 'step-confirm',
  components: {
    [TdInfoTag.name]: TdInfoTag,
  },
  props: {
    infoData: {
      typeof: Object,
      required: true,
    },
  },
  computed: {
    rows() {
      return [
        {
          label: i18n.t('common_words.code'),
          value: this.infoData.code,
        },
        {
          label: i18n.t('common_words.name'),
          value: this.infoData.name,
        },
        {
          label: i18n.t('common_words.type'),
          value: this.infoData.type,
        },
        {
          label: i18n.t('inventory.max_capacity'),
          value: this.infoData.maximum_capacity,
        },
        {
          label: i18n.t('inventory.max_capacity_unit'),
          value: this.infoData.supplying_unit_name,
        },
        {
          label: i18n.t('common_words.address'),
          value: this.infoData.address,
        },
        {
          label: i18n.t('common_words.latitude'),
          value: this.infoData.latitude,
        },
        {
          label: i18n.t('common_words.longitude'),
          value: this.infoData.longitude,
        },
        {
          label: i18n.t('common_words.altitude'),
          value: this.infoData.altitude,
        },
        {
          label: i18n.t('inventory.responsable_name'),
          value: this.infoData.responsable_name,
        },
        {
          label: i18n.t('inventory.responsable_lastname'),
          value: this.infoData.responsable_last_name,
        },
        {
          label: i18n.t('inventory.responsable_phone'),
          value: this.infoData.responsable_phone,
        },
        {
          label: i18n.t('inventory.responsable_email'),
          value: this.infoData.responsable_email,
        },
        {
          label: i18n.t('common_words.farms2'),
          value: this.infoData.farms_name,
          fieldTag: 'option',
        },
        {
          label: i18n.t('inventory.suppliers'),
          value: this.infoData.providers_name,
          fieldTag: 'option',
        },
        {
          label: i18n.t('inventory.article_category'),
          value: this.infoData.article_categories_name,
          fieldTag: 'option',
        },
        {
          label: i18n.t('inventory.articles'),
          value: this.infoData.articles_name,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.companies2'),
          value: this.infoData.businesses_names,
          fieldTag: 'option',
        },
      ];
    },
  },
  methods: {
    validateIsset(data) {
      return isset(data);
    },
    showInfoTag(info) {
      return (
        (typeof info.visibility === 'undefined' || Boolean(info.visibility)) &&
        this.validateIsset(info.value) &&
        Array.isArray(info.value)
      );
    },
  },
};
</script>
